import type { ClassNameProp } from '@ps/web-shared-components';
import React from 'react';

import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import styles from './ChestSprite.scss';

/**
 * Render the sprited chest with logo and icon
 * @param param0 - contains skin, logo, icon
 */

interface Props {
  skin: string;
  logo?: string;
  icon?: React.ComponentType<ClassNameProp>;
}

const ChestSprite: React.FC<Props> = ({ skin, logo, icon }) => {
  const skinStyle = { backgroundImage: `url(${skin})` };

  const logoStyle = getBackgroundImageStyle(logo);

  return (
    <div className={styles.chestSpriteContainer}>
      <div className={styles.chestImageLid} style={skinStyle} />
      <div className={styles.chestImageLidLock} style={skinStyle} />
      <div className={styles.chestImageContainer} style={skinStyle} />
      <div className={styles.chestImageShadow} style={skinStyle} />
      <div className={styles.chestImageLogo} style={logoStyle} />
      {icon && React.createElement(icon, { className: styles.chestLockIcon })}
    </div>
  );
};
export default ChestSprite;
